export function redirect(url: URL, delay = 0) {
    setTimeout(() => {
        window.location.assign(url.toString());
    }, delay);
}
